// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1qmva","text":"SelectPayment_text__11MDl","title":"SelectPayment_title__1_gD4","btn":"SelectPayment_btn__MQK1o"};